query GetHifoCascades(
  $page: Int!
  $limit: Int!
  $status: HifoCascadeStatusEnum
) {
  hifoCascades(page: $page, limit: $limit, status: $status) {
    collection {
      id
      status
      deadline
      currentTrancheNumber
      notes
      roomForFunding {
        currency
        minorUnit
      }
      minimumGrantAmount {
        currency
        minorUnit
      }
      hifo {
        id
        name
        roomForFunding {
          currency
          minorUnit
        }
        minDonationAmount {
          currency
          minorUnit
        }
      }
      owner {
        id
        name
      }
      pitches {
        id
        status
        pitchedAmount {
          currency
          minorUnit
        }
        committedAmount {
          currency
          minorUnit
        }
        grantedAmount {
          currency
          minorUnit
        }
      }
      createdBy {
        id
        email
      }
      updatedBy {
        id
        email
      }
      createdAt
      updatedAt
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
